import ArrowLeft from '@/assets/icons/arrow-left.svg?react'
import ArrowRight from '@/assets/icons/arrow-right.svg?react'
import { cn } from '@/utils/style'

interface PaginationProps {
  size: number
  total: number
  current: number
  className?: string
  onChange?: (page: number) => void
}

export function Pagination({ size, total, current, onChange, className }: PaginationProps) {
  const pageCount = Math.ceil(total / size)
  const arr = Array.from({ length: pageCount }, (_, i) => i + 1)
  let pageArr: (number | null)[] = []

  if (pageCount <= 7) {
    pageArr = arr
  } else if (current < 5) {
    pageArr = [...arr.slice(0, 5), null, pageCount]
  } else if (current > pageCount - 4) {
    pageArr = [1, null, ...arr.slice(pageCount - 5, pageCount)]
  } else {
    pageArr = [1, null, ...arr.slice(current - 3, current + 2), null, pageCount]
  }

  const basicClass =
    'rounded-md w-10 h-10 flex items-center justify-center t-sm cursor-pointer text-secondary select-none'

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div
        className={cn(basicClass, 'bg-panel-gray-100', {
          'text-tertiary cursor-not-allowed': current === 1,
        })}
        onClick={() => {
          if (current === 1) return
          onChange && onChange(current - 1)
        }}
      >
        <ArrowLeft />
      </div>

      {pageArr.map((p, i) => {
        return (
          <div
            key={i}
            className={cn(basicClass, {
              'bg-panel-gray-100': p === current,
            })}
            onClick={() => {
              if (p === null || p === current) {
                return
              }

              onChange && onChange(p)
            }}
          >
            {p === null ? '...' : p}
          </div>
        )
      })}

      <div
        className={cn(basicClass, 'bg-panel-gray-100', {
          'text-tertiary cursor-not-allowed': current === pageCount,
        })}
        onClick={() => {
          if (current === pageCount) return
          onChange && onChange(current + 1)
        }}
      >
        <ArrowRight />
      </div>
    </div>
  )
}
